import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasCargaserviciosImportarComponent {
  constructor (dialog, $dialogParams, $q) {
    this.dialog = dialog
    this.$q = $q
    this.procesador = $dialogParams['processor']
    this.options = {
      includeHeaders: false,
      headers: $dialogParams['headers'],
    }
    this.input = ''
    this.table = {
      maxColumns: 0,
      headers: [],
      rows: [],
    }
  }

  edit (cell) {
    cell.value = prompt('Ingrese el contenido de esta celda', cell.value) || cell.value
  }

  decodeInput () {
    if (this.input === '') return

    let columnsCount = 0

    this.table.rows = this.input.split('\n').map((row) => {
      let cells = row.split('\t')
      columnsCount = Math.max(columnsCount, cells.length)
      return cells.map((value) => ({value: value.trim(), valid: true}))
    })

    this.table.headers = this.options.includeHeaders
      ? this.table.rows.splice(0, 1)[0].map((cell) => cell.value.toUpperCase())
      : new Array(columnsCount)
  }

  clearInput () {
    this.input = ''
    this.table.rows = []
  }

  process () {
    let headers = this.table.headers.filter((item) => item)
    let data = []

    this.table.rows.forEach((row) => {
      let object = {}
      row.forEach((cell, index) => {
        const header = this.table.headers[index]
        if (header) object[header] = cell.value
      })
      data.push(object)
    })

    let procesar = this.procesador({data: data, headers: headers})

    this.$q.when(procesar).then((data) => (this.dialog.resolve(data)))
  }

  cancel () {
    this.dialog.reject()
  }
}

module.controller('NominasCargaserviciosImportar', NominasCargaserviciosImportarComponent)
module.config(($dialogProvider) => {
  $dialogProvider.dialog('nominas.cargaServicios.importar', {
    controller: 'NominasCargaserviciosImportar',
    template,
    controllerAs: '$ctrl',
    cancelable: false,
  })
})



// WEBPACK FOOTER //
// ./src/nominas/cargaservicios/components/importar/component.js